import { Clipboard } from '@angular/cdk/clipboard';

import { NavigationExtras, Router } from '@angular/router';
import { MdcSnackbar } from '@angular-mdc/web';
import { Component, Injectable, OnDestroy } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { Globals } from '../globals';
import { ProductoService } from '../servicios/producto.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BehaviorSubject, Subscription } from 'rxjs';
import { BusquedaService } from '../services/BusquedaService';
import { CategoriaServiceService } from '../servicios/categoria-service.service';
@Component({
  selector: 'app-buscador-productos',
  templateUrl: './buscador-productos.component.html', // Verifica la ruta y el nombre del archivo aquí
  styleUrls: ['./buscador-productos.component.scss']
})
@Injectable({
  providedIn: 'root'
})
export class BuscadorProductosComponent implements OnDestroy{
  mostrarBoton = false;
  tagDesdeUrl = 'recientes';
  mostrarSelect = true;
  params = null
  tagsField = "";
  tags = {
    cargando: false,
    registros: new Array()
  };
  private limpiarBusquedaSubscription: Subscription;
  constructor(
		public globals: Globals,
		private fb: FormBuilder,
    private router: Router,
		private productoService: ProductoService,
		private activatedRoute: ActivatedRoute,
		public clipboard: Clipboard,
		public dialog: MatDialog,
		private snackBar: MdcSnackbar,
    private busquedaService: BusquedaService,
    private route: ActivatedRoute,
    private categoriaService: CategoriaServiceService
	) {

    this.categoriaService.categoriaSeleccionada$.subscribe(categoria => {
      // Lógica para manejar el cambio de categoría
    
      this.cargarTags(categoria);
    });
    if(location.href.includes('/catalogo')){
      this.mostrarSelect = false;
    }else{
      this.mostrarSelect = true;
    }
    
    this.limpiarBusquedaSubscription = this.busquedaService.limpiarBusqueda$.subscribe(() => {
      this.vaciarBusqueda();
    });
    this.route.queryParams.subscribe(params => {
      this.params = params;
      const requiredParams = ['tag', 'tag_descripcion', 'buscar'];
      this.mostrarBoton = requiredParams.every(param => params.hasOwnProperty(param));

      //para agregar que el boton de copiar URL se muestre con los mas vendidos. El problema es que necesita guardar la categoria en la url tambien
      if(window.location.href.includes('ordenar_new')){
        this.mostrarBoton = true;
      }
      
      // alert(this.mostrarBoton)
    });
   }
   ngOnDestroy() {
    // Desuscribirse en OnDestroy para evitar fugas de memoria
    this.limpiarBusquedaSubscription.unsubscribe();
  }
  esRutaCatalogo(): boolean {
		return this.router.url.includes('/catalogo');
	}
  isJson(item: string): boolean {
    try {
      JSON.parse(item);
      return true;
    } catch (error) {
      return false;
    }
  }
  getTagValue(tag: any): string {
    // tag.idmodelo,tag.marca_modelo
    return JSON.stringify({ idmodelo: tag.idmodelo, marca_modelo: tag.marca_modelo });
  }
  getTagValueForDescription(description: string): string {
    const tag = this.tags.registros.find(t => t.tag_descripcion === description);
    return tag ? this.getTagValue(tag) : 'recientes';
  }
  setTagDesdeUrl() {
    this.route.queryParams.subscribe(params => {
      if(location.href.includes('ordenar_new=relevancia_producto')){
        this.tagDesdeUrl = 'vendidos';

      }
      if (params && params.tag_descripcion) {
        const tag = this.tags.registros.find(t => t.marca_modelo === params.tag_descripcion);
        this.tagDesdeUrl = tag ? this.getTagValue(tag) : 'recientes';
        
      }
    });
  }
  cargarTags(categoria = null){
    // console.log('this.globals.configuracion.front.listado.categoria',categoryid)
    if(categoria && categoria.categoriaId){
      this.globals.configuracion.front.listado.categoria = categoria.categoriaId;
    }
    // alert('categoria '+this.globals.configuracion.front.listado.categoria)
    if(location.href.includes('categoria=') && !this.globals.configuracion.front.listado.categoria){
      const params = new URLSearchParams(location.href.split('?')[1]);
      // Obtener los valores de los parámetros
      const categoriaPorUrl = params.get('categoria');
      this.globals.configuracion.front.listado.categoria = categoriaPorUrl
      // alert('categoria '+this.globals.configuracion.front.listado.categoria)
    
    }

    this.productoService.tagsListado({
      categoria: this.globals.configuracion.front.listado.categoria
    }).subscribe(
      resultado =>{
        if( !resultado.error ){
          // Array.prototype.push.apply( this.tags.registros, resultado.registros );
          // console.log('registros, resultado.registros ', resultado.registros )


          const registrosFiltrados = resultado.registros.filter(registroNuevo => {
            // Verificar si this.tags.registros ya contiene un elemento con el mismo idmodelo y marca_modelo
            return !this.tags.registros.some(registroExistente => 
                registroExistente.idmodelo === registroNuevo.idmodelo && 
                registroExistente.marca_modelo === registroNuevo.marca_modelo
            );
        });
        
        // Concatenar los registros filtrados a this.tags.registros
        // Array.prototype.push.apply(this.tags.registros, registrosFiltrados);
        this.tags.registros = resultado.registros;
          this.tags.cargando = false;
          this.setTagDesdeUrl();
          if(this.globals.configuracion.front.listado.ordenar == 'reciente' && !window.location.href.includes('tag') && !window.location.href.includes('tag_descripcion')){
            // alert(this.globals.configuracion.front.listado.ordenar)
            if(location.href.includes('ordenar_new=relevancia_producto')){
              this.tagDesdeUrl = 'vendidos';
      
            }else{

              this.tagDesdeUrl = 'recientes'
            }
          }
        }else{
          console.log("Error",resultado.mensaje);
        }

      },
      error =>{
        console.log("Error",error);
        //this.feedProductos.cargando = false;
      }
    )
  }
  navegarACatalogo(ordenar = null, ordenar_modo = null){
    if(ordenar && ordenar_modo){
      console.log("navegarACatalogo1")
      // this.formSearch.controls.busqueda.setValue("");
      this.globals.configuracion.front.listado.tag = "";
      this.globals.configuracion.front.listado.tag_descripcion = "";
      this.globals.configuracion.front.listado.tag_descripcion = "";
      this.globals.configuracion.front.listado.modelo = "";
      this.globals.configuracion.front.listado.ordenar_new = ordenar;
      this.globals.configuracion.front.listado.ordenar_modo = ordenar_modo;

      // Crear un objeto con los parámetros que deseas pasar
      const parametros = {
        ordenar_new: ordenar,
        ordenar_modo: ordenar_modo,
        pagina:1
      };
			localStorage.setItem("paginaActual",'1')

      // Crear un objeto de tipo NavigationExtras y asignar los parámetros
      const navigationExtras: NavigationExtras = {
        queryParams: parametros,
      };
      console.log('navigationExtras',navigationExtras)
      this.router.navigate([`/catalogo`],navigationExtras);

    }else{
      console.log("navegarACatalogo12")

      this.router.navigate([`/catalogo`]);
    }

  }
  tomarTag(tagId, modelo){
    console.log(tagId,modelo);
		this.globals.configuracion.front.listado.tag = tagId;
		this.globals.configuracion.front.listado.tag_descripcion = modelo;

    // Crear un objeto con los parámetros que deseas pasar
    const parametros = {
      tag: tagId,
      tag_descripcion: modelo,
      buscar:"",
      pagina:1
    };
    
    // Crear un objeto de tipo NavigationExtras y asignar los parámetros
    const navigationExtras: NavigationExtras = {
      queryParams: parametros,
    };

    this.router.navigate([`/catalogo`],navigationExtras);
		// this.search();
    // this.snackBar.open(`La categoría ${modelo} ha sido seleccionada`, 'Cerrar');

    // this.navegarACatalogo();
  }
  onSelectChange(event: Event): void {
    const selectedValue = (event.target as HTMLSelectElement).value;
    if(localStorage.getItem('scrollPosition') == null){
      console.log("AKA DM1")
      localStorage.setItem('paginaActual','1')
    }
    if (this.isJson(selectedValue)) {
      console.log("AKA DM12")
      const parsedValue = JSON.parse(selectedValue);
      // console.log('parsedValue',parsedValue)
      if (parsedValue.idmodelo && parsedValue.marca_modelo) {
        this.tomarTag(parsedValue.idmodelo, parsedValue.marca_modelo);
      }
    } else {
     
      // Manejo de valores no JSON
      if (selectedValue === 'recientes') {
        this.navegarACatalogo('reciente', 'desc');
      } else if (selectedValue === 'vendidos') {
        this.navegarACatalogo('relevancia_producto', 'desc');
      }
    }
  }
  ngOnInit() {
    // Verificar la URL actual al iniciar el componente
    
    this.tagsField = this.globals.configuracion.front.listado.tag;
    
    if(window.location.href.includes('tag') && window.location.href.includes('tag_descripcion')){
      // console.log("??")
    }else{

      this.cargarTags();
    }
    this.productosListado()
  }

	feedProductos = {
		cargando: true,
		productos: new Array(),
		paginaActual: 1,
	}

	formSearch = this.fb.group({
		busqueda:[
			this.globals.configuracion.front.listado.busqueda
		]
	});
  copiarClipboard(){
    
    let parametro = 'categoria';
    let valorCategoria = this.globals.configuracion.front.listado.categoria;
    let currentUrl = location.href;
    // Verifica si la URL ya tiene parámetros GET
    if (currentUrl.includes('?')) {
        // Si ya tiene parámetros, agrega el nuevo con un ampersand
        currentUrl += `&${parametro}=${encodeURIComponent(valorCategoria)}`;
    } else {
        // Si no tiene parámetros, inicia con un signo de interrogación
        currentUrl += `?${parametro}=${encodeURIComponent(valorCategoria)}`;
    }
	  this.clipboard.copy(currentUrl);
    this.snackBar.open("Se ha copiado la dirección de esta búsqueda.", 'Cerrar');

  }
  vaciarBusqueda() {
    this.formSearch.controls.busqueda.reset();
  }
  productosListado(){
    
    this.feedProductos.cargando = true;
   
    this.productoService.productoListado({
      pagina_actual: this.feedProductos.paginaActual++,
      busqueda: this.formSearch.controls.busqueda.value,
      categoria: this.globals.configuracion.front.listado.categoria,
      marca: this.globals.configuracion.front.listado.marca,
      modelo: this.globals.configuracion.front.listado.modelo,
      ordenar: this.globals.configuracion.front.listado.ordenar_new,
      ordenar_modo: this.globals.configuracion.front.listado.ordenar_modo,
      typeabbrev: this.globals.configuracion.front.typeabbrev,
      modelos: this.globals.configuracion.front.listado.modelos,
      tags: this.globals.configuracion.front.listado.tags,
      tag: this.globals.configuracion.front.listado.tag,
      }).subscribe(
      resultado =>{
        if( !resultado.error ){
          Array.prototype.push.apply( this.feedProductos.productos, resultado.registros );
          this.globals.feedProductos.productos = this.feedProductos.productos;
          this.feedProductos.cargando = false;
        }else{
          console.log("Error",resultado.mensaje);
        }

      },
      error =>{
        console.log("Error",error);
        //this.feedProductos.cargando = false;
      }
    )
  }
  
  search(){
    // if(!this.globals.configuracion.front.listado.categoria){
    //   this.snackBar.open("Debe seleccinar una categoria", 'Cerrar');
    //   this.router.navigate(['/']);
    //   return;
    // }
    localStorage.setItem('busqueda',this.formSearch.controls.busqueda.value)
    localStorage.setItem("paginaActual",""+1)
    
    if (this.router.url !== '/catalogo') {
      const parametros = {
        value: this.formSearch.controls.busqueda.value,
        pagina:1,
        buscar:true,
        firstTime:true,
      };
  
      // Crear un objeto de tipo NavigationExtras y asignar los parámetros
      const navigationExtras: NavigationExtras = {
        queryParams: parametros,
      };
  
      this.router.navigate([`/catalogo`],navigationExtras);
    
      // Redirigir al usuario a la vista del catálogo
      // this.router.navigateByUrl('/catalogo');
    }
    //cuando se busca algo por el input debe buscar en todo el catelogo
    this.globals.configuracion.front.listado.busqueda = this.formSearch.controls.busqueda.value;
    this.globals.configuracion.front.listado.marca = '';
    this.globals.configuracion.front.listado.modelo = '';
    this.globals.configuracion.front.listado.categoria = '';
    this.globals.configuracion.front.listado.tag = '';
		
    this.globals.setDataFront();
    this.feedProductos.productos.splice( 0 );
    this.feedProductos.paginaActual = 1;
    this.productosListado();
  }

  buscarPorCodigoBarras() {
    // Aquí implementa la lógica para buscar por el código de barras
    console.log('Escaneando código de barras...');
  }
}
